import { DocumentApi } from 'Api/Document/DocumentApi';
import { FileManagementAreaWithSiblings, FileManagementAreaWithSiblingsHookValues } from 'Components/Files/FileManagementArea';
import { UnansweredQuestionMarker } from 'Components/RequiresAttentionMarker/UnansweredQuestionMarker';
import { Text, TextProps } from 'Components/Text/Text';
import { IrqQuestionFileUpload, IrqQuestionType } from 'Models/InherentRisk';

interface QuestionFileUploadProps {
    documentApi: DocumentApi;
    fileManagementHookValues: FileManagementAreaWithSiblingsHookValues;
    question: IrqQuestionFileUpload;
    questionNumber: number;
    showUnansweredQuestionMarker: boolean;
    uniqueIdForFileManagementArea: string;

    disabled?: boolean;
    questionTextVariant?: TextProps['variant'];
}

/**
 * Renders a question that requires the user to upload one or more files.
 * Currently used only for the IRQ.
 */
export const QuestionFileUpload = (props: QuestionFileUploadProps) => {
    return (
        <>
            <Text variant={props.questionTextVariant ?? 'Text2'}>{`${props.questionNumber}. ${props.question.text}`}</Text>
            {props.showUnansweredQuestionMarker && <UnansweredQuestionMarker questionIsRequired questionType={IrqQuestionType.FILE_UPLOAD} />}
            <FileManagementAreaWithSiblings uniqueId={props.uniqueIdForFileManagementArea} disabled={props.disabled ?? false} documentApi={props.documentApi} fileManagementHookValues={props.fileManagementHookValues} />
        </>
    );
};
